import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { AgenticReviewClient, makeReviewApiRef } from './api';
import { MAKE_REVIEW_ROUTES } from './navigation';

const makeReviewApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: makeReviewApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AgenticReviewClient({ discoveryApi, fetchApi }),
    }),
});

const makeReviewPage = PageBlueprint.make({
  params: {
    path: MAKE_REVIEW_ROUTES.overview.path,
    title: 'Make Review',
    routeRef: rootRouteRef,
    // The overview, run and session pages render their own BUI Header.
    noHeader: true,
    loader: () =>
      import('./components/MakeReviewPage').then(m => <m.MakeReviewPage />),
  },
});

const legacyRedirectPage = PageBlueprint.make({
  name: 'legacy-redirect',
  params: {
    path: '/agentic-review',
    noHeader: true,
    loader: () =>
      import('./components/LegacyMakeReviewRedirect').then(m => (
        <m.LegacyMakeReviewRedirect />
      )),
  },
});

export const makeReviewPlugin = createFrontendPlugin({
  pluginId: 'make-review',
  title: 'Make Review',
  routes: {
    root: rootRouteRef,
  },
  extensions: [makeReviewApi, makeReviewPage, legacyRedirectPage],
});

export default makeReviewPlugin;
